<template>
  <div class="dialog1">
    <!-- 安全生产许可证 -->
    <el-dialog
      v-if="title == '安全生产许可证' ? dialogFormVisible : false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible="title == '安全生产许可证' ? dialogFormVisible : false"
      center
      :show-close="false"
      append-to-body
      custom-class="zhengjia1"
    >
      <el-form ref="form" :model="form" disabled>
        <el-form-item label="证件编号:" label-width="91px" prop="zjbh">
          <el-input v-model="form.zjbh" placeholder="请输入证件编号" />
        </el-form-item>
        <el-form-item label="单位名称: " label-width="91px" prop="dwmc">
          <el-input v-model="form.dwmc" placeholder="请输入单位名称" />
        </el-form-item>
        <el-form-item label="主要负责人:" prop="fzr" label-width="91px">
          <el-input
            v-model="form.fzr"
            placeholder="请输入主要负责人"
          />
        </el-form-item>
        <el-form-item label="经济类型:" label-width="91px" prop="jjlx">
          <el-input v-model="form.jjlx" placeholder="请输入经济类型" />
        </el-form-item>
        <el-form-item label="注册地址:" label-width="91px" prop="dz">
          <el-input v-model="form.dz" placeholder="请输入注册地址" />
        </el-form-item>

        <el-form-item label="许可范围:" label-width="91px" prop="jyfw">
          <el-input
            v-model="form.jyfw"
            type="textarea"
            :rows="3"
            resize="none"
            placeholder="请输入许可范围"
          />
        </el-form-item>

        <el-form-item label="有效期:" label-width="91px">
          <el-col :span="11.5">
            <el-form-item prop="yxqKs">
              <el-date-picker
                v-model="form.yxqKs"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="line"
            :span="1"
            style="margin: 0 5px; text-align: center; width: 20px"
          >
            <span>至</span>
          </el-col>
          <el-col :span="11.5">
            <el-form-item prop="yxqJs">
              <el-date-picker
                v-model="form.yxqJs"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="91px" label="发证机关:" prop="fzjg">
          <el-input v-model="form.fzjg" placeholder="请输入发证机关" />
        </el-form-item>
        <el-form-item label-width="91px" label="发证日期:" prop="fzrq">
          <el-date-picker
            v-model="form.fzrq"
            type="date"
            placeholder="请输入发证日期"
            style="width: 174px"
          />
        </el-form-item>

        <el-form-item>
          <div class="fujian">上传附件（{{ fileList.length }}/6）</div>
          <el-upload
            :headers="token"
            class="avatar-uploader"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button    v-preventReClick   @click="closeDialog('form')">取 消</el-button> -->
        <el-button
          v-preventReClick
          type="primary"
          @click="submitForm('form')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!-- 非药品类易制毒化学品生产许可证-->
    <el-dialog
      v-if="
        title == '非药品类易制毒化学品生产许可证' ? dialogFormVisible : false
      "
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible="
        title == '非药品类易制毒化学品生产许可证' ? dialogFormVisible : false
      "
      center
      :show-close="false"
      append-to-body
      custom-class="zhengjia2"
    >
      <el-form ref="form" :model="form" disabled>
        <el-form-item label="编号:" label-width="91px" prop="zjbh">
          <el-input v-model="form.zjbh" placeholder="请输入证件编号" />
        </el-form-item>
        <el-form-item label-width="91px" label="生产品种:" prop="hxpMcs">
          <el-input
            v-model="form.hxpMcs"
            placeholder="请选择"
            @focus="innerVisible1 = true"
          />
        </el-form-item>
        <el-form-item label="单位名称:" label-width="91px" prop="dwmc">
          <el-input v-model="form.dwmc" placeholder="请输入单位名称" />
        </el-form-item>
        <el-form-item label="经济类型:" label-width="91px" prop="jjlx">
          <el-input v-model="form.jjlx" placeholder="请输入经济类型" />
        </el-form-item>
        <el-form-item label="主要流向:" label-width="91px" prop="zylx">
          <el-input v-model="form.zylx" placeholder="请输入主要流向" />
        </el-form-item>

        <el-form-item label="主要负责人:" prop="fzr" label-width="91px">
          <el-input
            v-model="form.fzr"
            placeholder="请输入主要负责人"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="单位地址:" prop="dz">
          <el-input v-model="form.dz" placeholder="请输入单位地址" />
        </el-form-item>
        <el-form-item label-width="91px" label="有效期:">
          <el-col :span="11.5">
            <el-form-item prop="yxqKs">
              <el-date-picker
                v-model="form.yxqKs"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="line"
            :span="1"
            style="margin: 0 5px; text-align: center; width: 20px"
          >
            <span>至</span>
          </el-col>
          <el-col :span="11.5">
            <el-form-item prop="yxqJs">
              <el-date-picker
                v-model="form.yxqJs"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="91px" label="发证机关:" prop="fzjg">
          <el-input v-model="form.fzjg" placeholder="请输入发证机关" />
        </el-form-item>
        <el-form-item label-width="91px" label="发证日期:" prop="fzrq">
          <el-date-picker
            v-model="form.fzrq"
            type="date"
            placeholder="请输入发证日期"
            style="width: 174px"
          />
        </el-form-item>

        <el-form-item>
          <div class="fujian">上传附件（{{ fileList.length }}/1）</div>
          <el-upload
            :headers="token"
            class="avatar-uploader"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <!-- <el-button    v-preventReClick   @click="closeDialog('form')">取 消</el-button> -->
        <el-button
          v-preventReClick
          type="primary"
          @click="submitForm('form')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!-- 非药品类易制毒化学品生产备案证明 -->
    <el-dialog
      v-if="
        title == '非药品类易制毒化学品生产备案证明' ? dialogFormVisible : false
      "
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible="
        title == '非药品类易制毒化学品生产备案证明' ? dialogFormVisible : false
      "
      center
      :show-close="false"
      append-to-body
      custom-class="zhengjia3"
    >
      <el-form ref="form" :model="form" disabled>
        <el-form-item label-width="91px" label="编号:" prop="zjbh">
          <el-input v-model="form.zjbh" placeholder="请输入证件编号" />
        </el-form-item>
        <el-form-item label-width="91px" label="品种类别:" prop="pzlb">
          <el-input v-model="form.pzlb" placeholder="请输入品种类别" />
        </el-form-item>
        <el-form-item label-width="91px" label="单位名称:" prop="dwmc">
          <el-input v-model="form.dwmc" placeholder="请输入单位名称" />
        </el-form-item>
        <el-form-item label-width="91px" label="生产品种:" prop="hxpMcs">
          <el-input
            v-model="form.hxpMcs"
            placeholder="请输入生产品种"
            @focus="innerVisible2 = true"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="经济类型:" prop="jjlx">
          <el-input v-model="form.jjlx" placeholder="请输入经济类型" />
        </el-form-item>
        <el-form-item label-width="91px" label="主要流向:" prop="zylx">
          <el-input v-model="form.zylx" placeholder="请输入主要流向" />
        </el-form-item>

        <el-form-item label="主要负责人:" prop="fzr" label-width="91px">
          <el-input
            v-model="form.fzr"
            placeholder="请输入主要负责人"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="发证机关:" prop="fzjg">
          <el-input v-model="form.fzjg" placeholder="请输入发证机关" />
        </el-form-item>
        <el-form-item label-width="91px" label="单位地址:" prop="dz">
          <el-input v-model="form.dz" placeholder="请输入单位地址" />
        </el-form-item>
        <el-form-item label-width="91px" label="有效期:">
          <el-col :span="11.5">
            <el-form-item prop="yxqKs">
              <el-date-picker
                v-model="form.yxqKs"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="line"
            :span="1"
            style="margin: 0 5px; text-align: center; width: 20px"
          >
            <span>至</span>
          </el-col>
          <el-col :span="11.5">
            <el-form-item prop="yxqJs">
              <el-date-picker
                v-model="form.yxqJs"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
        </el-form-item>

        <el-form-item label-width="91px" label="发证日期:" prop="fzrq">
          <el-date-picker
            v-model="form.fzrq"
            type="date"
            placeholder="请输入发证日期"
            style="width: 174px"
          />
        </el-form-item>

        <el-form-item>
          <div class="fujian">上传附件（{{ fileList.length }}/1）</div>
          <el-upload
            :headers="token"
            class="avatar-uploader"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <!-- <el-button    v-preventReClick   @click="closeDialog('form')">取 消</el-button> -->
        <el-button
          v-preventReClick
          type="primary"
          @click="submitForm('form')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!-- 非药品类易制毒化学品经营许可证4-->
    <el-dialog
      v-if="
        title == '非药品类易制毒化学品经营许可证' ? dialogFormVisible : false
      "
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible="
        title == '非药品类易制毒化学品经营许可证' ? dialogFormVisible : false
      "
      center
      :show-close="false"
      append-to-body
      custom-class="zhengjia3"
    >
      <el-form ref="form" :model="form" disabled>
        <el-form-item label-width="91px" label="证件编号:" prop="zjbh">
          <el-input v-model="form.zjbh" placeholder="请输入证件编号" />
        </el-form-item>
        <el-form-item
          label-width="137px"
          label="统一社会信用代码:"
          prop="tyshxydm"
        >
          <el-input v-model="form.tyshxydm" placeholder="请输入" />
        </el-form-item>
        <el-form-item label-width="91px" label="经营品种:" prop="pzcl">
          <el-input
            v-model="form.pzcl"
            placeholder="请输入(生产或经营)品种"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="单位名称:" prop="dwmc">
          <el-input v-model="form.dwmc" placeholder="请输入单位名称" />
        </el-form-item>
        <el-form-item label-width="91px" label="经济类型:" prop="jjlx">
          <el-input v-model="form.jjlx" placeholder="请输入经济类型" />
        </el-form-item>
        <el-form-item label="主要负责人:" prop="fzr" label-width="91px">
          <el-input
            v-model="form.fzr"
            placeholder="请输入主要负责人"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="主要流向:" prop="zylx">
          <el-input v-model="form.zylx" placeholder="请输入主要流向" />
        </el-form-item>
        <el-form-item label-width="91px" label="发证机关:" prop="fzjg">
          <el-input v-model="form.fzjg" placeholder="请输入发证机关" />
        </el-form-item>
        <el-form-item label-width="91px" label="单位地址:" prop="dz">
          <el-input v-model="form.dz" placeholder="请输入单位地址" />
        </el-form-item>
        <el-form-item label-width="91px" label="有效期:">
          <el-col :span="11.5">
            <el-form-item prop="yxqKs">
              <el-date-picker
                v-model="form.yxqKs"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="line"
            :span="1"
            style="margin: 0 5px; text-align: center; width: 20px"
          >
            <span>至</span>
          </el-col>
          <el-col :span="11.5">
            <el-form-item prop="yxqJs">
              <el-date-picker
                v-model="form.yxqJs"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
        </el-form-item>

        <el-form-item label-width="91px" label="发证日期:" prop="fzrq">
          <el-date-picker
            v-model="form.fzrq"
            type="date"
            placeholder="请输入发证日期"
            style="width: 174px"
          />
        </el-form-item>

        <el-form-item>
          <div class="fujian">上传附件（{{ fileList.length }}/1）</div>
          <el-upload
            :headers="token"
            class="avatar-uploader"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeUpload"
            :on-preview="handlePictureCardPreview"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button    v-preventReClick   @click="closeDialog('form')">取 消</el-button> -->
        <el-button
          v-preventReClick
          type="primary"
          @click="submitForm('form')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!-- 危险化学品经营许可证5 -->
    <el-dialog
      v-if="title == '危险化学品经营许可证' ? dialogFormVisible : false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible="title == '危险化学品经营许可证' ? dialogFormVisible : false"
      center
      :show-close="false"
      append-to-body
      custom-class="zhengjia5"
    >
      <el-form ref="form" :model="form" disabled>
        <el-form-item label-width="91px" label="证件编号:" prop="zjbh">
          <el-input v-model="form.zjbh" placeholder="请输入证件编号" />
        </el-form-item>
        <el-form-item label-width="91px" label="单位名称:" prop="dwmc">
          <el-input v-model="form.dwmc" placeholder="请输入单位名称" />
        </el-form-item>
        <el-form-item label-width="91px" label="单位住所:" prop="dz">
          <el-input v-model="form.dz" placeholder="请输入单位住所" />
        </el-form-item>
        <el-form-item label="单位法定代表人:" prop="fzr" label-width="120px">
          <el-input v-model="form.fzr" placeholder="请输入" />
        </el-form-item>

        <el-form-item label-width="91px" label="经营方式:" prop="jjlx">
          <el-input v-model="form.jjlx" placeholder="请输入经营方式" />
        </el-form-item>
        <el-form-item label-width="91px" label="发证机关:" prop="fzjg">
          <el-input v-model="form.fzjg" placeholder="请输入发证机关" />
        </el-form-item>
        <el-form-item label-width="91px" label="许可范围:" prop="jyfw">
          <el-input
            v-model="form.jyfw"
            type="textarea"
            :rows="3"
            resize="none"
            placeholder="请输入许可范围"
          />
        </el-form-item>

        <el-form-item label-width="91px" label="有效期:">
          <el-col :span="11.5">
            <el-form-item prop="yxqKs">
              <el-date-picker
                v-model="form.yxqKs"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="line"
            :span="1"
            style="margin: 0 5px; text-align: center; width: 20px"
          >
            <span>至</span>
          </el-col>
          <el-col :span="11.5">
            <el-form-item prop="yxqJs">
              <el-date-picker
                v-model="form.yxqJs"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="91px" label="发证日期:" prop="fzrq">
          <el-date-picker
            v-model="form.fzrq"
            type="date"
            placeholder="请选择发证日期"
            style="width: 174px"
          />
        </el-form-item>
        <el-form-item label-width="115px" label="有效期延续至:" prop="yxqyxz">
          <el-date-picker
            v-model="form.yxqyxz"
            type="date"
            placeholder="请选择"
            style="width: 174px"
          />
        </el-form-item>

        <el-form-item>
          <div class="fujian">上传附件（{{ fileList.length }}/6）</div>
          <el-upload
            :headers="token"
            class="avatar-uploader"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button    v-preventReClick   @click="closeDialog('form')">取 消</el-button> -->
        <el-button
          v-preventReClick
          type="primary"
          @click="submitForm('form')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!-- 非药品类易制毒化学品经营备案证明6 -->
    <el-dialog
      v-if="
        title == '非药品类易制毒化学品经营备案证明' ? dialogFormVisible : false
      "
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible="
        title == '非药品类易制毒化学品经营备案证明' ? dialogFormVisible : false
      "
      center
      :show-close="false"
      append-to-body
      custom-class="zhengjia6"
    >
      <el-form ref="form" :model="form" disabled>
        <el-form-item label-width="91px" label="证件编号:" prop="zjbh">
          <el-input v-model="form.zjbh" placeholder="请输入证件编号" />
        </el-form-item>
        <el-form-item label-width="91px" label="单位名称:" prop="dwmc">
          <el-input v-model="form.dwmc" placeholder="请输入单位名称" />
        </el-form-item>
        <el-form-item label="主要负责人:" prop="fzr" label-width="91px">
          <el-input
            v-model="form.fzr"
            placeholder="请输入主要负责人"
          />
        </el-form-item>
        <el-form-item
          label-width="135px"
          label="统一社会信用代码:"
          prop="tyshxydm"
        >
          <el-input v-model="form.tyshxydm" placeholder="请输入" />
        </el-form-item>
        <el-form-item label-width="91px" label="品种类别:" prop="pzlb">
          <el-input v-model="form.pzlb" placeholder="请输入" />
        </el-form-item>
        <el-form-item label-width="91px" label="经营品种:" prop="pzcl">
          <el-input v-model="form.pzcl" placeholder="请输入" />
        </el-form-item>
        <el-form-item label-width="91px" label="经济类型:" prop="jjlx">
          <el-input v-model="form.jjlx" placeholder="请输入经济类型" />
        </el-form-item>

        <el-form-item label-width="91px" label="主要流向:" prop="zylx">
          <el-input v-model="form.zylx" placeholder="请输入主要流向" />
        </el-form-item>

        <el-form-item label-width="91px" label="单位地址:" prop="dz">
          <el-input v-model="form.dz" placeholder="请输入单位地址" />
        </el-form-item>
        <el-form-item label-width="91px" label="有效期:">
          <el-col :span="11.5">
            <el-form-item prop="yxqKs">
              <el-date-picker
                v-model="form.yxqKs"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="line"
            :span="1"
            style="margin: 0 5px; text-align: center; width: 20px"
          >
            <span>至</span>
          </el-col>
          <el-col :span="11.5">
            <el-form-item prop="yxqJs">
              <el-date-picker
                v-model="form.yxqJs"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="91px" label="发证机关:" prop="fzjg">
          <el-input v-model="form.fzjg" placeholder="请输入发证机关" />
        </el-form-item>
        <el-form-item label-width="91px" label="发证日期:" prop="fzrq">
          <el-date-picker
            v-model="form.fzrq"
            type="date"
            placeholder="请输入发证日期"
            style="width: 174px"
          />
        </el-form-item>

        <el-form-item>
          <div class="fujian">上传附件（{{ fileList.length }}/1）</div>
          <el-upload
            :headers="token"
            class="avatar-uploader"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button    v-preventReClick   @click="closeDialog('form')">取 消</el-button> -->
        <el-button
          v-preventReClick
          type="primary"
          @click="submitForm('form')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!--道路运输经营许可证7 -->
    <el-dialog
      v-if="title == '道路运输经营许可证' ? dialogFormVisible : false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible="title == '道路运输经营许可证' ? dialogFormVisible : false"
      center
      :show-close="false"
      append-to-body
      custom-class="zhengjia7"
    >
      <el-form ref="form" :model="form" disabled>
        <el-form-item label-width="91px" label="证件编号:" prop="zjbh">
          <el-input v-model="form.zjbh" placeholder="请输入证件编号" />
        </el-form-item>
        <el-form-item label-width="91px" label="业户名称:" prop="dwmc">
          <el-input v-model="form.dwmc" placeholder="请输入" />
        </el-form-item>
        <el-form-item label-width="91px" label="地址:" prop="dz">
          <el-input v-model="form.dz" placeholder="请输入地址" />
        </el-form-item>
        <el-form-item label-width="91px" label="经营范围:" prop="jyfw">
          <el-input
            v-model="form.jyfw"
            type="textarea"
            :rows="3"
            resize="none"
            placeholder="请输入经营范围"
          />
        </el-form-item>

        <el-form-item label-width="91px" label="证件有效期:">
          <el-col :span="11.5">
            <el-form-item prop="yxqKs">
              <el-date-picker
                v-model="form.yxqKs"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="line"
            :span="1"
            style="margin: 0 5px; text-align: center; width: 20px"
          >
            <span>至</span>
          </el-col>
          <el-col :span="11.5">
            <el-form-item prop="yxqJs">
              <el-date-picker
                v-model="form.yxqJs"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="91px" label="核发机关:" prop="fzjg">
          <el-input v-model="form.fzjg" placeholder="请输入核发机关" />
        </el-form-item>
        <el-form-item label-width="91px" label="核发日期:" prop="fzrq">
          <el-date-picker
            v-model="form.fzrq"
            type="date"
            placeholder="请输入核发日期"
            style="width: 174px"
          />
        </el-form-item>

        <el-form-item>
          <div class="fujian">上传附件（{{ fileList.length }}/6）</div>
          <el-upload
            :headers="token"
            class="avatar-uploader"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button    v-preventReClick   @click="closeDialog('form')">取 消</el-button> -->
        <el-button
          v-preventReClick
          type="primary"
          @click="submitForm('form')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!--其他证件8-->
    <el-dialog
      v-if="title == '其他证件' ? dialogFormVisible : false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible="title == '其他证件' ? dialogFormVisible : false"
      center
      :show-close="false"
      append-to-body
      custom-class="zhengjia8"
    >
      <el-form ref="form" :model="form" disabled>
        <el-form-item label-width="91px" label="证件名称:" prop="zsmc">
          <el-input v-model="form.zsmc" placeholder="请输入" />
        </el-form-item>
        <el-form-item label-width="91px" label="证件编号:" prop="zjbh">
          <el-input v-model="form.zjbh" placeholder="请输入证件编号" />
        </el-form-item>

        <el-form-item label-width="91px" label="证件有效期:">
          <el-col :span="11.5">
            <el-form-item prop="yxqKs">
              <el-date-picker
                v-model="form.yxqKs"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="line"
            :span="1"
            style="margin: 0 5px; text-align: center; width: 20px"
          >
            <span>至</span>
          </el-col>
          <el-col :span="11.5">
            <el-form-item prop="yxqJs">
              <el-date-picker
                v-model="form.yxqJs"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="91px" label="发证机关:" prop="fzjg">
          <el-input v-model="form.fzjg" placeholder="请输入发证机关" />
        </el-form-item>
        <el-form-item label-width="91px" label="发证日期:" prop="fzrq">
          <el-date-picker
            v-model="form.fzrq"
            type="date"
            placeholder="请输入发证日期"
            style="width: 174px"
          />
        </el-form-item>
        <el-form-item>
          <div class="fujian">上传附件（{{ fileList.length }}/6）</div>
          <el-upload
            :headers="token"
            class="avatar-uploader"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button    v-preventReClick   @click="closeDialog('form')">取 消</el-button> -->
        <el-button
          v-preventReClick
          type="primary"
          @click="submitForm('form')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!--合法使用需要证明9 -->
    <el-dialog
      v-if="title == '合法使用需要证明' ? dialogFormVisible : false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible="title == '合法使用需要证明' ? dialogFormVisible : false"
      center
      :show-close="false"
      append-to-body
      custom-class="zhengjia9"
    >
      <el-form ref="form" :model="form" disabled>
        <el-form-item label-width="91px" label="单位名称:" prop="dwmc">
          <el-input v-model="form.dwmc" placeholder="请输入单位名称" />
        </el-form-item>
        <el-form-item label-width="91px" label="化学品:" prop="hxpMcs">
          <el-input
            v-model="form.hxpMcs"
            placeholder="请输入化学品"
            @focus="innerVisible = true"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="涉及量:" prop="sjl">
          <el-input v-model="form.sjl" placeholder="请输入涉及量" />
        </el-form-item>

        <el-form-item label-width="91px" label="签订日期:" prop="fzrq">
          <el-date-picker
            v-model="form.fzrq"
            type="date"
            placeholder="请输入签订日期"
            style="width: 174px"
          />
        </el-form-item>
        <el-form-item>
          <div class="fujian">上传附件（{{ fileList.length }}/6）</div>
          <el-upload
            :headers="token"
            class="avatar-uploader"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>

          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <!-- <el-button    v-preventReClick   @click="closeDialog('form')">取 消</el-button> -->
        <el-button
          v-preventReClick
          type="primary"
          @click="submitForm('form')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!-- 危险货物道路运输许可证 -->
    <el-dialog
      v-if="title == '危险货物道路运输许可证' ? dialogFormVisible : false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible="title == '危险货物道路运输许可证' ? dialogFormVisible : false"
      center
      :show-close="false"
      append-to-body
      custom-class="zhengjia10"
    >
      <el-form ref="form" :model="form" disabled>
        <el-form-item label-width="91px" label="证件编号:" prop="zjbh">
          <el-input v-model="form.zjbh" placeholder="请输入证件编号" />
        </el-form-item>
        <el-form-item label-width="91px" label="业户名称:" prop="dwmc">
          <el-input v-model="form.dwmc" placeholder="请输入" />
        </el-form-item>
        <el-form-item label-width="91px" label="地址:" prop="dz">
          <el-input v-model="form.dz" placeholder="请输入地址" />
        </el-form-item>
        <el-form-item label-width="91px" label="经营范围:" prop="jyfw">
          <el-input
            v-model="form.jyfw"
            type="textarea"
            :rows="3"
            resize="none"
            placeholder="请输入经营范围"
          />
        </el-form-item>

        <el-form-item label-width="91px" label="证件有效期:">
          <el-col :span="11.5">
            <el-form-item prop="yxqKs">
              <el-date-picker
                v-model="form.yxqKs"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="line"
            :span="1"
            style="margin: 0 5px; text-align: center; width: 20px"
          >
            <span>至</span>
          </el-col>
          <el-col :span="11.5">
            <el-form-item prop="yxqJs">
              <el-date-picker
                v-model="form.yxqJs"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="91px" label="发证机关:" prop="fzjg">
          <el-input v-model="form.fzjg" placeholder="请输入发证机关" />
        </el-form-item>
        <el-form-item label-width="91px" label="发证日期:" prop="fzrq">
          <el-date-picker
            v-model="form.fzrq"
            type="date"
            placeholder="请输入发证日期"
            style="width: 174px"
          />
        </el-form-item>

        <el-form-item>
          <div class="fujian">上传附件（{{ fileList.length }}/6）</div>
          <el-upload
            :headers="token"
            class="avatar-uploader"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!--<el-button    v-preventReClick   @click="closeDialog('form')">取 消</el-button> -->
        <el-button
          v-preventReClick
          type="primary"
          @click="submitForm('form')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!-- 营业执照 -->
    <el-dialog
      v-if="title == '营业执照' ? dialogFormVisible : false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible="title == '营业执照' ? dialogFormVisible : false"
      center
      :show-close="false"
      append-to-body
      custom-class="zhengjia11"
    >
      <el-form ref="form" :model="form" disabled>
        <el-form-item label-width="91px" label="证件编号:" prop="zjbh">
          <el-input v-model="form.zjbh" placeholder="请输入证件编号" />
        </el-form-item>
        <el-form-item label-width="91px" label="单位名称:" prop="dwmc">
          <el-input v-model="form.dwmc" placeholder="请输入" />
        </el-form-item>
        <el-form-item label-width="91px" label="单位地址:" prop="dz">
          <el-input v-model="form.dz" placeholder="请输入地址" />
        </el-form-item>
        <el-form-item label-width="91px" label="法人/经营者:" prop="fzr">
          <el-input v-model="form.fzr" placeholder="请输入地址" />
        </el-form-item>

        <el-form-item label-width="91px" label="证件有效期:">
          <el-col :span="11.5">
            <el-form-item prop="yxqKs">
              <el-date-picker
                v-model="form.yxqKs"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="line"
            :span="1"
            style="margin: 0 5px; text-align: center; width: 20px"
          >
            <span>至</span>
          </el-col>
          <el-col :span="11.5">
            <el-form-item prop="yxqJs">
              <el-date-picker
                v-model="form.yxqJs"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="91px" label="发证机关:" prop="fzjg">
          <el-input v-model="form.fzjg" placeholder="请输入发证机关" />
        </el-form-item>
        <el-form-item label-width="91px" label="发证日期:" prop="fzrq">
          <el-date-picker
            v-model="form.fzrq"
            type="date"
            placeholder="请输入发证日期"
            style="width: 174px"
          />
        </el-form-item>

        <el-form-item>
          <div class="fujian">上传附件（{{ fileList.length }}/6）</div>
          <el-upload
            :headers="token"
            class="avatar-uploader"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!--<el-button    v-preventReClick   @click="closeDialog('form')">取 消</el-button> -->
        <el-button
          v-preventReClick
          type="primary"
          @click="submitForm('form')"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  url1,
  getToken,
  returnSaveFile,
  returnShowPic,
  getHxpTree
} from '@/assets/js/common.js'

export default {
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: {}
    },
    title: {
      type: String,
      default: {}
    },
    zjlx: {
      // 证件类型
      type: Number,
      default: {}
    }
  },
  data() {
    return {
      HxpTree: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      token: {
        Authorization: getToken()
      },
      returnSaveFile: '', // 保存图片
      returnShowPic: '', // 回显图片
      URL1: '',
      dialogImageUrl: '', // uploaded组件自带
      dialogVisible: false, // uploaded组件自带
      fileList: [], // uploaded组件自带
      imageUrl: '',
      imglist: [], // 存取开始的图片
      length: 0, // 弹框的高度跟随数量变化
      form: {
        hxpIds: '', // "化学品编码，多个逗号分隔",
        hxpMcs: '', // "化学品，多个逗号分隔",
        jyfw: '', // "（许可）经营范围",
        zzdj: '', // "资质等级",
        pzlb: '', // "品种类别",
        zsmc: '', // "证书名称",
        zjnr: '', // "证件内容",
        sjl: '', // "涉及量",
        yxqyxz: '',
        tyshxydm: '', // "统一社会信用代码",
        status: '0',
        zjbh: '', // 编号
        pzcl: '', // 生产,经营（品种,产量）
        dwmc: '', // 单位名称
        zylx: '', // 主要流向
        jjlx: '', // 经济类型
        fzr: '', // 主要负责人
        dz: '', // 单位地址
        yxqKs: '', // 有效期
        yxqJs: '', // 有效期
        fzjg: '', // 发证机关
        fzrq: '' // 发证日期
      },

      imageurlone: '',
      closeBox: false
    }
  },
  watch: {
    dialogVisible(val) {
      this.dialogVisible = val
    }
  },
  created() {
    this.URL1 = url1()
    this.returnSaveFile = returnSaveFile()
    this.returnShowPic = returnShowPic()
    // 化学品树
    getHxpTree().then((e) => {
      this.HxpTree = e.data.data
    })
  },
  mounted() {},
  methods: {
    csh(dataMes) {
      console.log(dataMes, 'dataMes')
      this.form = Object.assign(
        {},
        {
          hxpIds: dataMes.dwfjSjxxDto.hxpIds, // "化学品编码，多个逗号分隔",
          hxpMcs: dataMes.dwfjSjxxDto.hxpMcs, // "化学品，多个逗号分隔",
          jyfw: dataMes.dwfjSjxxDto.jyfw, // "（许可）经营范围",
          zzdj: dataMes.dwfjSjxxDto.zzdj, // "资质等级",
          pzlb: dataMes.dwfjSjxxDto.pzlb, // "品种类别",
          zsmc: dataMes.dwfjSjxxDto.zsmc, // "证书名称",
          zjnr: dataMes.dwfjSjxxDto.zjnr, // "证件内容",
          sjl: dataMes.dwfjSjxxDto.sjl, // "涉及量",
          yxqyxz: dataMes.dwfjSjxxDto.yxqyxz,
          tyshxydm: dataMes.dwfjSjxxDto.tyshxydm, // "统一社会信用代码",
          status: dataMes.dwfjSjxxDto.status,
          id: dataMes.dwfjSjxxDto.id, // 主键
          zjbh: dataMes.dwfjSjxxDto.zjbh, // 编号
          pzcl: dataMes.dwfjSjxxDto.pzcl, // 生产,经营（品种,产量）
          dwmc: dataMes.dwfjSjxxDto.dwmc, // 单位名称
          zylx: dataMes.dwfjSjxxDto.zylx, // 主要流向
          jjlx: dataMes.dwfjSjxxDto.jjlx, // 经济类型
          fzr: dataMes.dwfjSjxxDto.fzr, // 主要负责人
          dz: dataMes.dwfjSjxxDto.dz, // 单位地址
          yxqKs: dataMes.dwfjSjxxDto.yxqKs, // 有效期
          yxqJs: dataMes.dwfjSjxxDto.yxqJs, // 有效期
          fzjg: dataMes.dwfjSjxxDto.fzjg, // 发证机关
          fzrq: dataMes.dwfjSjxxDto.fzrq // 发证日期
        }
      )

      this.imglist = []
      this.fileList = []
      dataMes.dwfjDtos.forEach((item) => {
        this.imglist.push({
          url: this.returnShowPic + item.wjdz,
          id: item.id
        })
        this.imageurlone = this.returnShowPic + item.wjdz
      })
      this.fileList = this.imglist

      if (this.title.includes('非药品类易制毒化学品')) this.closeBox = true
    },
    // 上传之前
    beforeUpload(file) {
      const fileType = ['image/jpeg', 'image/png', 'image/bmp', 'image/jpg']
      const isJPG = fileType.includes(file.type)

      const isLt = file.size / 1024 < 500
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/BMP/JPEG/PNG格式!')
      }
      if (!isLt) {
        this.$message.error('上传图片大小不能超过 500kb!')
      }
      return isJPG && isLt
    },
    // 确定许可证验证
    submitForm(formName) {
      this.reset('form')
    },
    reset(formName) {
      this.$nextTick(() => {
        this.$refs[formName].resetFields()
        this.$emit('close-dialog')
      })
      this.form.hxpIds = ''
      this.form.hxpMcs = ''
      this.form.pzcl = ''
      this.fileList = []
      this.imglist = []
      this.length = 0
      this.closeBox = false
      this.imageurlone = ''
    },
    // 关闭许可证弹窗
    closeDialog(formName) {
      this.reset(formName)
    },
    // 成功
    handleAvatarSuccess(res, file) {
      this.addFjxxs.push({
        zjlx: this.zjlx,
        wjdz: res.data.url
      })
      if (this.title.includes('非药品类易制毒化学品')) {
        this.imageurlone = this.returnShowPic + res.data.url
        this.closeBox = true
      }
    },
    // 点击文件列表中已上传的文件，预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    }
  }
}
</script>
<style lang="less" scoped>
.deleteUpload {
  width: 25px;
  height: 25px;
  position: absolute;
  right: 0;
  top: -24px;
  cursor: pointer;
}
/deep/.zhengjia1,
/deep/.zhengjia2,
/deep/.zhengjia3,
/deep/.zhengjia4,
/deep/.zhengjia5,
/deep/.zhengjia6,
/deep/.zhengjia7,
/deep/.zhengjia8,
/deep/.zhengjia9,
/deep/.zhengjia10,
/deep/.zhengjia11 {
  border-radius: 5px;
  width: 1136px;
  margin-top: 5vh !important;
  .el-dialog__title {
    display: block;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 28px;
    margin: 30px auto 42px;
  }
  .el-dialog__body {
    padding: 0 112px !important;
    .el-form {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      .el-textarea__inner {
        font-family: PingFangSC-Regular, PingFang SC;
      }
      .el-form-item {
        margin-bottom: 20px;
        .el-input {
          width: 340px;
          height: 39px;
        }
        .el-form-item__label {
          padding-right: 6px;
        }
        & > :last-child {
          margin-left: 21px;
        }
      }
    }
  }
  .el-dialog__footer {
    padding: 10px 20px 83px;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 174px !important;
    // width: 100% !important;
  }
}
/deep/.zhengjia1 {
  .el-form-item {
    //注册地址
    &:nth-child(5) {
      width: 100%;
      .el-input {
        width: 100% !important;
      }
    }
    //许可范围
    &:nth-child(6) {
      width: 100%;
      .el-input {
        width: 100%;
      }
    }
    //有效期
    &:nth-child(7) {
      width: 52% !important;
      height: 39px;
      [class*="el-col-11.5"] {
        width: 174px !important;
        .el-form-item__content {
          margin: 0 !important;
        }
      }
    }
    //发证日期
    &:nth-child(9) {
      width: 100%;
    }
  }
}
/deep/.zhengjia2 {
  .el-form-item {
    //单位地址
    &:nth-child(7) {
      width: 100%;
      .el-input {
        width: 100% !important;
      }
    }
    //有效期
    &:nth-child(8) {
      width: 52% !important;
      height: 39px;
      [class*="el-col-11.5"] {
        width: 174px !important;
        .el-form-item__content {
          margin: 0 !important;
        }
      }
    }
    // 发证日期
    &:nth-child(10) {
      width: 100%;
    }
  }
}
/deep/.zhengjia3 {
  .el-form-item {
    //单位地址
    &:nth-child(9) {
      width: 100%;
      .el-input {
        width: 100% !important;
      }
    }
    //有效期
    &:nth-child(10) {
      width: 52% !important;
      height: 39px;
      [class*="el-col-11.5"] {
        width: 174px !important;
        .el-form-item__content {
          margin: 0 !important;
        }
      }
    }
    // 发证日期
    &:nth-child(11) {
      width: 47%;
      .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 100% !important;
      }
    }
  }
}

/deep/.zhengjia5 {
  .el-form-item {
    //许可范围
    &:nth-child(7) {
      width: 100%;
      .el-input {
        width: 100% !important;
      }
    }
    //有效期
    &:nth-child(8) {
      width: 52% !important;
      height: 39px;
      [class*="el-col-11.5"] {
        width: 174px !important;
        .el-form-item__content {
          margin: 0 !important;
        }
      }
    }

    &:nth-child(9),
    &:nth-child(10) {
      width: 50%;
      .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 100% !important;
      }
    }
  }
}
/deep/.zhengjia6 {
  .el-form-item {
    //有效期
    &:nth-child(10) {
      width: 52% !important;
      height: 39px;
      [class*="el-col-11.5"] {
        width: 174px !important;
        .el-form-item__content {
          margin: 0 !important;
        }
      }
    }

    &:nth-child(9) {
      width: 100%;
      .el-input {
        width: 100% !important;
      }
    }
    &:nth-child(12) {
      width: 100%;
    }
  }
}
/deep/.zhengjia7,
/deep/.zhengjia10 {
  .el-form-item {
    //有效期
    &:nth-child(5) {
      width: 52% !important;
      height: 39px;
      [class*="el-col-11.5"] {
        width: 174px !important;
        .el-form-item__content {
          margin: 0 !important;
        }
      }
    }

    &:nth-child(3),
    &:nth-child(4) {
      width: 100%;
      .el-input {
        width: 100% !important;
      }
    }

    &:nth-child(7) {
      width: 100%;
    }
  }
}

/deep/.zhengjia11 {
  .el-form-item {
    //有效期
    &:nth-child(5) {
      width: 52% !important;
      height: 39px;
      [class*="el-col-11.5"] {
        width: 174px !important;
        .el-form-item__content {
          margin: 0 !important;
        }
      }
    }
    &:nth-child(7) {
      width: 100%;
    }
  }
}
/deep/.zhengjia8 {
  .el-form-item {
    //有效期
    &:nth-child(3) {
      width: 52% !important;
      height: 39px;
      [class*="el-col-11.5"] {
        width: 174px !important;
        .el-form-item__content {
          margin: 0 !important;
        }
      }
    }

    &:nth-child(5) {
      width: 100%;
    }

    &:nth-child(7) {
      width: 100%;
    }
  }
}
/deep/.zhengjia9 {
  .el-form-item {
    &:nth-child(4) {
      width: 47.5%;
    }
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100% !important;
  }
}

/deep/.avatar-uploader .el-upload {
  // border: 1px dashed #d9d9d9;
  border: 0 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
/deep/.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 96px !important;
  height: 96px !important;
  line-height: 96px !important;
  text-align: center;
  background: #f3f3f3;
  border-radius: 3px;
}
/deep/.el-upload {
  line-height: 96px !important;
}
.avatar {
  display: block;
}
.fujian {
  width: 124px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 22px;
  margin-bottom: 25px;
}

/deep/.el-upload-list--picture-card .el-upload-list__item,
/deep/.el-upload--picture-card {
  width: 96px !important;
  height: 96px !important;
}

.el-button {
  // width: 148px;
  // height: 60px;
  // padding: 20px 60px;
  margin: 0 40px;
}
.el-button--primary {
  background: #4170ff !important;
}
.yulan .el-dialog {
  height: 340px;
  width: 400px;
}

/deep/.el-upload--picture-card {
  display: none;
}
// /deep/.v-modal {
//   z-index: 0 !important;
// }
</style>
